/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 包含待解码文本 'text' 的JSON对象
 */
export type PostTextBase64DecodeRequest = { text: string };

export const PostTextBase64DecodeRequest$zodSchema: z.ZodType<
  PostTextBase64DecodeRequest
> = z.object({
  text: z.string(),
}).describe("包含待解码文本 'text' 的JSON对象");

export type PostTextBase64DecodeDetails = {};

export const PostTextBase64DecodeDetails$zodSchema: z.ZodType<
  PostTextBase64DecodeDetails
> = z.object({});

/**
 * 无效的请求参数或解码失败
 */
export type PostTextBase64DecodeBadRequestResponseBody = {
  code?: string | undefined;
  details?: PostTextBase64DecodeDetails | undefined;
  message?: string | undefined;
};

export const PostTextBase64DecodeBadRequestResponseBody$zodSchema: z.ZodType<
  PostTextBase64DecodeBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostTextBase64DecodeDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("无效的请求参数或解码失败");

/**
 * 成功响应
 */
export type PostTextBase64DecodeResponseBody = { decoded?: string | undefined };

export const PostTextBase64DecodeResponseBody$zodSchema: z.ZodType<
  PostTextBase64DecodeResponseBody
> = z.object({
  decoded: z.string().optional(),
}).describe("成功响应");

export type PostTextBase64DecodeResponse =
  | PostTextBase64DecodeResponseBody
  | PostTextBase64DecodeBadRequestResponseBody;

export const PostTextBase64DecodeResponse$zodSchema: z.ZodType<
  PostTextBase64DecodeResponse
> = z.union([
  z.lazy(() => PostTextBase64DecodeResponseBody$zodSchema),
  z.lazy(() => PostTextBase64DecodeBadRequestResponseBody$zodSchema),
]);
